import {
  SET_SELECTED_USER,
  SET_USERS,
  SET_USERS_LOADED,
  SET_USER_FILTER,
  SET_USER_TYPES,
  SET_USER_TYPES_LOADED,
  UserAction,
  UserState,
} from '../types'

const initialState: UserState = {
  users: [],
  isUsersLoaded: false,
  userTypes: [],
  isUserTypesLoaded: false,
  userFilter: {
    name: '',
    username: '',
    phone: '',
    genders: ['true', 'false'],
    userTypes: [],
  },
}

export const userReducer = (
  state = initialState,
  action: UserAction
): UserState => {
  switch (action.type) {
    case SET_USER_FILTER:
      return {
        ...state,
        userFilter: action.payload,
      }
    case SET_SELECTED_USER:
      return {
        ...state,
        selectedUser: action.payload,
      }
    case SET_USERS:
      return {
        ...state,
        users: action.payload,
      }
    case SET_USERS_LOADED:
      return {
        ...state,
        isUsersLoaded: action.payload,
      }
    case SET_USER_TYPES:
      return {
        ...state,
        userTypes: action.payload,
      }
    case SET_USER_TYPES_LOADED:
      return {
        ...state,
        isUserTypesLoaded: action.payload,
      }
    default:
      return state
  }
}
